import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { jsx as e, jsxs as o } from "react/jsx-runtime";
import { Component as t, cloneElement as i, Children as n } from "react";
import { calculateRem as l, generateUUID as r } from "@vds-core/utilities";
import a from "react-focus-lock";
import d from "styled-components";
import { ColorTokens as s } from "@vds-tokens/color";
import { ResizeObserver as c } from "@juggle/resize-observer";
import u from "./ModalCloseButton.js";
import p from "./ModalContainer.js";
import m from "./ModalDialog.js";
import h from "./ModalOverlay.js";
import f from "./util/screen-reader.js";
import v from "./util/scroll-lock.js";
var g = function g(e) {
    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    return "mobile" === e ? o ? "16px 0px" : "16px 16px 16px 4px" : "0px";
  },
  b = function b(e) {
    var o = parseInt(e, 10),
      t = String(e).replace(/^[\d.-]+/, "");
    return "vh" === t ? document.documentElement.clientHeight * o / 100 - 96 : "%" === t ? document.documentElement.clientHeight * o / 100 - 96 - 32 : o - 96;
  },
  y = "undefined" != typeof window && window.ResizeObserver ? window.ResizeObserver : c,
  w = {
    className: null,
    closeButton: void 0,
    customScroll: !1,
    disableOutsideClick: !1,
    modalOpened: !1,
    opened: !1,
    unmounted: !1,
    modalHeight: void 0,
    modalWidth: void 0,
    disableFocusLock: !1,
    viewport: "desktop",
    fullScreenDialog: !1
  },
  x = d.div.withConfig({
    displayName: "ModalDialogWrapper",
    componentId: "VDS__sc-lpxb3o-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: ", ";\n  min-height: ", ";\n  padding: ", ";\n\n  @media (max-width: 767px) {\n    padding: ", ";\n  }\n  *::-webkit-scrollbar {\n    display: none;\n  }\n  *:not(select) {\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n\n  @media only screen and (min-width: 767px) {\n    &::-webkit-scrollbar {\n      display: none;\n    }\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n\n  @media only screen and (max-width: 767px) {\n    &::-webkit-scrollbar {\n      display: ", ";\n    }\n    scrollbar-width: auto;\n    -ms-overflow-style: auto;\n  }\n"])), function (_ref) {
    var e = _ref.viewport;
    return "mobile" !== e ? "hidden" : "auto";
  }, l(136), function (_ref2) {
    var e = _ref2.viewport,
      o = _ref2.$fullWidthContent;
    return g(e, o);
  }, function (_ref3) {
    var e = _ref3.$fullWidthContent;
    return g("mobile", e);
  }, function (_ref4) {
    var e = _ref4.viewport,
      o = _ref4.$scrollPos;
    return "mobile" === e && (null != o ? o : 0) <= 0 ? "none" : "auto";
  }),
  C = d.span.withConfig({
    displayName: "ChildWrapper",
    componentId: "VDS__sc-lpxb3o-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  padding: ", "; // If fullWidthContent is false, Added 4px to left and 3px to bottom to account of hover + focusring of Buttons/RadioBoxes\n  @media (max-width: 767px) {\n    padding: 0;\n  }\n"])), function (_ref5) {
    var e = _ref5.$fullWidthContent;
    return e ? "0" : "0 0 3px 4px";
  });
var k = /*#__PURE__*/function (_t) {
  _inherits(k, _t);
  function k(o) {
    var _this;
    _classCallCheck(this, k);
    var t;
    _this = _possibleConstructorReturn(this, _getPrototypeOf(k).call(this, o)), t = _assertThisInitialized(_assertThisInitialized(_this)), _this.isFirefox = "undefined" != typeof navigator && navigator.userAgent.toLowerCase().indexOf("firefox") > -1, _this._getCloseButton = function (o) {
      var n = {
          top: "0px",
          right: "0px",
          height: "48px",
          width: "48px",
          interactiveStates: !0,
          backgroundColor: "dark" === o.surface ? s.background.primary.dark.value : s.background.primary.light.value,
          size: "large"
        },
        l = o.closeButton;
      return void 0 === l && u ? e(u, {
        toggleButton: o.toggleButton,
        onClick: o.toggleModal,
        isAppleDevice: o.isAppleDevice,
        unmounted: o.unmounted,
        hovered: o.hovered,
        isKeyboardInteraction: o.isKeyboardInteraction,
        ariaLabel: o.ariaLabel,
        "data-analyticstrack": o.analyticsTrack,
        "data-track": o.track,
        "data-track-ignore": o.ignoreTrack,
        "data-clickstream": o.clickStream,
        "data-sitecat-cta": o.cta,
        "data-sitecat-level": o.level,
        "data-sitecat-position": o.position,
        "data-sitecat-datatrack": o.dataTrack,
        surface: o.surface,
        scrollbarId: o.scrollbarId,
        borderRadius: o.borderRadius,
        closeButtonFocusBorderRadius: o.closeButtonFocusBorderRadius,
        id: o.closeButtonId,
        onKeyDown: t._handleOnKeyDown,
        viewport: o.viewport
      }) : null === o.closeButton ? null : o.closeButton && void 0 === o.closeButton.props.onClick ? i(l, {
        onClick: o.toggleModal,
        styleConfig: n,
        onKeyDown: t._handleOnKeyDown
      }) : i(l, {
        styleConfig: n,
        onKeyDown: function onKeyDown(e) {
          l.props.onKeyDown && l.props.onKeyDown(e), t._handleOnKeyDown(e);
        }
      });
    }, _this._setScrollProperty = function (e) {
      var o = "undefined" != typeof document ? document.getElementById("scrollbar-view-".concat(t.props.scrollbarId)) : null;
      o && (o.style.scrollBehavior = "smooth", o.scrollTop += e);
    }, _this._handleOnKeyDown = function (e) {
      var o;
      if (("undefined" != typeof document ? document.getElementById("scrollbar-view-".concat(t.props.scrollbarId)) : null) && (40 === e.keyCode ? t._setScrollProperty(45) : 38 === e.keyCode && t._setScrollProperty(-45)), (32 === e.keyCode || 13 === e.keyCode) && t.isFirefox) {
        var _e = "undefined" != typeof document ? null === (o = null === document || void 0 === document ? void 0 : document.getElementById("modal-close-button")) || void 0 === o ? void 0 : o.classList : null;
        null == _e || _e.add("active");
      }
    }, _this.calScrollHeight = function () {
      var e;
      var o = b(t.props.maxHeight);
      t.childrenContainer && t.setState({
        modalScrollHeight: t.childrenContainer.clientHeight <= o ? l(null === (e = t.childrenContainer) || void 0 === e ? void 0 : e.clientHeight) : 0
      });
    }, _this.handleScroll = function () {
      var e;
      t.setState({
        scrollTop: null === (e = t.dialogContainerRef) || void 0 === e ? void 0 : e.scrollTop
      });
    }, _this.state = {
      modalScrollHeight: 0,
      scrollTop: 0
    }, _this.componentId = "component-".concat(r()), _this.childContentObs = "undefined" != typeof window && new y(function () {
      window.requestAnimationFrame(function () {
        t.calScrollHeight();
      });
    });
    return _this;
  }
  _createClass(k, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var e,
        o,
        t = this;
      this.childrenContainer && this.dialogContainerRef && (null === (o = null === (e = this.childContentObs) || void 0 === e ? void 0 : e.observe) || void 0 === o || o.call(e, this.childrenContainer), this.dialogContainerRef.addEventListener("scroll", this.handleScroll)), v.enable(), this.props.isMobileDevice && !this.props.isAppleDevice && f.OpenDialog(), "undefined" != typeof document && document.addEventListener("fullscreenchange", function () {
        null === document.fullscreenElement && (clearTimeout(t.fullScreenTimeDelay), t.fullScreenTimeDelay = setTimeout(function () {
          t.calScrollHeight();
        }, 100));
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(e, o) {
      this.props.viewport !== e.viewport && this.childContentObs.observe(this.childrenContainer);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var e, o;
      v.disable(), null === (o = null === (e = this.dialogContainerRef) || void 0 === e ? void 0 : e.removeEventListener) || void 0 === o || o.call(e, "scroll", this.handleScroll), this.props.isMobileDevice && !this.props.isAppleDevice && f.CloseDialog(), this.childContentObs.unobserve(this.childrenContainer), clearTimeout(this.fullScreenTimeDelay);
    }
  }, {
    key: "render",
    value: function render() {
      var t = this;
      var _this$props = this.props,
        r = _this$props.children,
        d = _this$props.className,
        s = _this$props.disableOutsideClick,
        c = _this$props.modalOpened,
        u = _this$props.opened,
        f = _this$props.toggleModal,
        v = _this$props.unmounted,
        g = _this$props.modalHeight,
        y = _this$props.modalWidth,
        w = _this$props.isMobileDevice,
        k = _this$props.viewport,
        D = _this$props.fullScreenDialog,
        $ = _this$props.animationDistance,
        S = _this$props.clickStream,
        B = _this$props.analyticsTrack,
        I = _this$props.track,
        O = _this$props.ignoreTrack,
        M = _this$props.zIndex,
        H = _this$props.disableFocusLock,
        T = _this$props.id,
        R = _this$props.disableAnimation,
        W = _this$props.surface,
        _ = _this$props.borderRadius,
        j = _this$props.scrollThumbBorderRadius,
        K = _this$props.ScrollWrapper,
        A = _this$props.closeButton,
        E = _this$props.footerIndex,
        F = _this$props.isAppleDevice,
        L = _this$props.fullWidthContent,
        z = _this$props.maxHeight,
        P = _this$props.maxWidth,
        N = "mobile" !== k;
      return e(p, {
        id: T,
        $zIndex: M,
        children: e(a, {
          noFocusGuards: w && !F,
          disabled: H,
          returnFocus: !0,
          children: e(h, {
            disableOutsideClick: s,
            onDismiss: f,
            modalOpened: c,
            unmounted: v,
            fullScreenDialog: D,
            viewport: k,
            surface: W,
            children: o(m, {
              modalHeight: g,
              $modalWidth: y,
              className: d,
              $unmounted: v,
              $modalOpened: c,
              $opened: u,
              role: "dialog",
              "aria-labelledby": null === A ? "ModalTitle-".concat(this.componentId) : void 0,
              "aria-describedby": null === A ? "ModalBody-".concat(this.componentId) : void 0,
              "aria-modal": "true",
              viewport: k,
              $fullScreenDialog: D,
              $animationDistance: $,
              "data-analyticstrack": B,
              "data-track": I,
              "data-track-ignore": O,
              "data-clickstream": S,
              $disableAnimation: R,
              $mobileHeight: "undefined" != typeof window && window.innerHeight,
              surface: W,
              $borderRadius: _,
              $fullWidthContent: L,
              $maxHeight: z,
              $maxWidth: P,
              children: [this._getCloseButton(this.props), e(x, {
                viewport: k,
                $fullScreenDialog: D,
                $isMobileDevice: w,
                id: N ? void 0 : this.props.contentContainer,
                ref: function ref(e) {
                  t.dialogContainerRef = e;
                },
                $scrollbarId: this.props.scrollbarId,
                $fullWidthContent: L,
                $scrollPos: this.state.scrollTop,
                children: N && K ? e(K, {
                  minHeight: l(136),
                  height: D ? "calc(100vh - 94px)" : this.state.modalScrollHeight ? this.state.modalScrollHeight.toString() : "".concat(b(z), "px"),
                  width: L ? "100%" : "calc(100% - 11px)",
                  contentStyle: {
                    display: "flex",
                    flexDirection: "column",
                    paddingRight: L ? 6 : 26
                  },
                  id: this.props.contentContainer,
                  surface: W,
                  scrollbarId: this.props.scrollbarId,
                  borderRadius: j,
                  children: e(C, {
                    viewport: k,
                    ref: function ref(e) {
                      t.childrenContainer = e;
                    },
                    $fullWidthContent: L,
                    children: n.map(r, function (e) {
                      var o;
                      return e && ("ModalTitle" === e.type.name && (o = "ModalTitle-".concat(t.componentId)), "ModalBody" === e.type.name && (o = "ModalBody-".concat(t.componentId))), i(e, Object.assign(Object.assign({}, null == e ? void 0 : e.props), {
                        surface: W,
                        viewport: k,
                        closeButton: {
                          closeButton: A
                        },
                        id: o,
                        footerIndex: {
                          footerIndex: E
                        },
                        isMobileDevice: {
                          isMobileDevice: w
                        }
                      }));
                    })
                  })
                }) : e(C, {
                  $fullWidthContent: L,
                  viewport: k,
                  ref: function ref(e) {
                    t.childrenContainer = e;
                  },
                  children: n.map(r, function (e) {
                    return i(e, Object.assign(Object.assign({}, null == e ? void 0 : e.props), {
                      surface: W,
                      viewport: k,
                      closeButton: {
                        closeButton: A
                      },
                      footerIndex: {
                        footerIndex: E
                      },
                      isMobileDevice: {
                        isMobileDevice: w
                      }
                    }));
                  })
                })
              })]
            })
          })
        })
      });
    }
  }]);
  return k;
}(t);
k.defaultProps = w;
export { k as default };